module.exports = "/_next/static/images/SANTAI_MTWI-8baabed4a00cf47d2de4c48c993a6b3b.svg";